<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cdqfYC/tc-custom/9781611521054.jpg?1723404114086" alt="This image is the cover for the book Bruised"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bruised
      </h1>
      <p class="bookDescription body article font2">
        <p>It's the last semester of vet school for David Livingston, and he's loving his job at a Thoroughbred farm. He loves the mares, he loves the foals, he loves the stallions, and, uh oh, he's starting to fall for the farm's charismatic owner, Marcus too. It's all very confusing for a guy who's never been interested in another man before.<br/><br/>When Marcus takes a tumble from a horse, it's up to David to help him out, but it's almost too much for David to handle. Stitching up Marcus's wound is challenging enough, but can David control his feelings too? Find out who gets <i>Bruised</i> .</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vincent Diamond
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?12f3ac13